import { render, staticRenderFns } from "./DevPageKD6.vue?vue&type=template&id=4828d068&scoped=true"
import script from "./DevPageKD6.vue?vue&type=script&lang=js"
export * from "./DevPageKD6.vue?vue&type=script&lang=js"
import style0 from "./DevPageKD6.vue?vue&type=style&index=0&id=4828d068&prod&lang=css"
import style1 from "./DevPageKD6.vue?vue&type=style&index=1&id=4828d068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828d068",
  null
  
)

export default component.exports